import { Pipe, PipeTransform } from '@angular/core';

import { identificadoresSocios } from '../socio-identificador';

@Pipe({
    name: 'socioIdentificador'
})
export class SocioIdentificadorPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = identificadoresSocios.findIndex(identificador => identificador.id === value);
        if (index > -1) {
            return identificadoresSocios[index].nome;
        }

        return '';
    }
}
